import { render, staticRenderFns } from "./Vx.vue?vue&type=template&id=befe914e&scoped=true"
import script from "./Vx.vue?vue&type=script&lang=js"
export * from "./Vx.vue?vue&type=script&lang=js"
import style0 from "./Vx.vue?vue&type=style&index=0&id=befe914e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe914e",
  null
  
)

export default component.exports